import { useEffect, useState } from "react";
import "./styles.css";

import icon from "../../assets/iconwhats.png";

const CtaWpp = (props) => {
  const [text, setText] = useState("(43) 99196-3101");

  useEffect(() => {
    if (props.text !== undefined) setText(props.text);
  }, [props.text]);

  return (
    <button id="ctaWpp">
      <a
        href="http://wa.me/+5543991963101?text=Olá,%20Gostaria%20de%20fazer%20um%20orçamento"
        target="_blank"
        rel="noreferrer"
      >
        <figure>
          <img src={icon} alt="Ícone do Whatsapp" />
        </figure>

        <p>{text}</p>
      </a>
    </button>
  );
};

export default CtaWpp;
